import React, { useEffect } from 'react'
import * as d3 from "d3"
import { PieArcDatum } from 'd3'
import "../PieChart/PieChart.css"


interface Props{
  data: { label: string, value: number }[],
  outerRadius: number, innerRadius: number, 
  colorMap?:{[key:string]:string}
}

export default function PieChart({data,outerRadius,innerRadius,colorMap}: Props) {
  const margin = { top:50, right: 50, left: 50, bottom: 50 }
  const width = 1.5 * outerRadius + margin.left + margin.right
  const height = 2 * outerRadius + margin.top + margin.bottom

  useEffect(() => {
    DrawChart()
  }, [data])
  
  function DrawChart() {
    let MaxValue = 0
    data.forEach(item => MaxValue = MaxValue + item.value)
    console.log(MaxValue)
    const colorScale = d3.scaleSequential()
                         .interpolator(d3.interpolateCool)
                         .domain([0,data.length])
    d3.select("#Pie-Chart-Container").select("svg").remove()
    
    const svg = d3.select("#Pie-Chart-Container").append("svg")
                  .attr("width", width).attr("height",height).append("g")
                  .attr("transform",`translate(${width/2},${height/2.7})`)
    if (data.length<= 0) svg.remove()
    const arcGenerator = d3.arc<PieArcDatum<{ label: string, value: number }>>()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius)
    const pieGenerator = d3.pie<{ label: string, value: number }>()
      .value((d) => d.value).sort((a, b) =>d3.ascending(a.value, b.value))
  
    const arc = svg.selectAll().data(pieGenerator(data)).enter()
    arc.merge(arc).append('path').transition().duration((d,i)=>i*190+190)
      .attr('d', arcGenerator)
      .style('fill', (data, i) => colorMap?colorMap[data.data.label] : colorScale(i))
      .style('stroke', 'black')
      .style('stroke-width', 2)
    
    arc.append("text").attr("text-anchor", "middle")
      .attr('alignment-baseline', 'middle')
      .text((d) => `${Math.round((d.data.value / MaxValue) * 100)}%`)
      .style("fill", "#00000").attr("transform", (d) => {
         const [x, y] = arcGenerator.centroid(d)
         return `translate(${x}, ${y})`
      })
    
    arc.exit().remove()
    DrawLegend(svg)
  }

  function DrawLegend(targetElement: d3.Selection<SVGGElement,unknown, HTMLElement, any>) {
    const colorScale = d3.scaleSequential()
                         .interpolator(d3.interpolateCool)
                         .domain([0,data.length])
    targetElement.selectAll("dots").data(data).enter()
      .append("circle").style('stroke', "black").style('stroke-width', 2)
      .attr("cx",0-margin.right).attr("cy", (d, i) => { return margin.bottom*2.5 + i * 25 })
      .attr("r", 10).style("fill", (d, i) => colorMap?colorMap[d.label] : colorScale(i))
    
  targetElement.selectAll("mylabels").data(data).enter().append("text")
    .attr("x", 0-margin.right+15).attr("y", function(d,i){ return margin.bottom*2.5+ i*25}) 
    .style("fill","var(--Color-3)")
    .text(function(d){ return `${d.label} —— ${d.value}`})
    .attr("text-anchor", "left")
    .style("alignment-baseline", "middle")
  }
  return (
    <div id='Pie-Chart-Container'>
      {data.length<= 0? <strong className='Error-Msg'>No data to display yet...</strong>:""}
    </div>
  )
}